{
  "DELIVERY_PLUS_ADDRESS": "Delivery + Address",
  "CONDITIONS": "Conditions",
  "PRIMARY_CONTACT": "Primary contact",
  "PRH_PRISLISTABESKR": "Price list",
  "XX_VALKOD": "Currency",
  "X1_MOMSBESKRIVNING": "VAT",
  "FR_FTGLEVPOSTNR": "Delivery Zip Code",
  "X1K_LEVSATTBESKR": "Customer category",
  "KP_FTGPERSON": "Name",
  "X1K_KUNDKATBESKR": "Customer category",
  "REF_CUSTOMER_CREATE_ERROR": "Error when creating customer.",
  "CUSTOMER_CREATE_FORM_ERROR": "Create new customer form contains errors. Revise the fields.",
  "CUSTOMER_CREATE_SUCCESS": "Customer created with success",
  "PROMOTIONS": "Promotions",
  "CARE": "Care",
  "STYLING": "Styling",
  "PROFESSIONAL": "Professional",
  "FR_FTGPOSTADR2_INVOICE": "Delivery address (Invoice)",
  "FR_FTGPOSTADR1_INVOICE": "Town (Invoice)",
  "FR_FTGPOSTNR_INVOICE": "Zip code (Invoice)",
  "FR_FTGPOSTADR3": "City (Invoice)",
  "MADE_A_PURCHASE_LAST_TWO_MONTHS": "Last two months",
  "MADE_A_PURCHASE_LAST_FIVE_MONTHS": "Last five months",
  "CUSTOMER_CATEGORY": "Customer category",
  "VARUGRUPPSKOD": "Product commodity group",
  "VOLUME": "Volume",
  "INACTIVE_CUSTOMERS": "Inactive customers",
  "CHOOSE_TIMESPAN": "Choose timespan",
  "TWO_MONTHS": "Two months",
  "FIVE_MONTHS": "Five months",
  "1_YEAR": "1 year",
  "2_YEARS": "2 years",
  "PRODUCT_COMMODITY_GROUP": "Product commodity group",
  "EDIT_CUSTOMER": "Edit customer",
  "UPDATE_CUSTOMER": "Update customer",
  "NOT_VALID_EMAIL": "Not valid email",
  "CUSTOMER_UPDATE_SUCCESS": "Customer updated with success",
  "CUSTOMER_UPDATE_ERROR": "Error when updating customer.",
  "CUSTOMER_UPDATE_FORM_ERROR": "Update customer form contains errors. Revise the fields.",
  "DISPATCH_DATE": "Dispatch date",
  "DISPATCH_DATE_REQUIRED": "The Delivery Date is required",
  "st": "pcs",
  "REF_DELIVERY_LOCATION_CHECKOUT_STEP_NEXT_BUTTON": "Moving next you confirm the delivery location",
  "REF_FH_FAKTURATYP_INVOICE": "Invoice",
  "REF_FH_FAKTURATYP_CREDIT": "Credit",
  "REF_KUNDKLASS": "Customer classification",
  "FR_FTGPOSTADR3_INVOICE": "Town (delivery)",
  "COST": "Cost",
  "MARKTING_EMAIL": "Marketing e-mail",
  "INVOICE_EMAIL_ADDRESS": "Invoice address",
  "NEW_CUSTOMER_ORDER": "New customer order"
}
